/**
 * Mock temporal para probar el listado de notas agrupadas por mes/año y paginación.
 * Eliminar o desactivar USE_MOCK_NOTES en NotesTabContext cuando la API esté lista.
 * Nota: los filtros locales (search/category) en este archivo son temporales
 * para demo/validación UX y deben retirarse al conectar el endpoint real.
 *
 * Estructura compatible con la respuesta de listNoteActivities.
 * getMockNotesListResponse(page, pageSize) devuelve la página solicitada para probar paginación.
 */

const MOCK_NOTES_FULL_BODY = [
    // Card mock con TODOS los iconos del footer (demo visual — según Figma Meta data Activity items list)
    {
      noteUuid: 'mock-all-icons-footer',
      noteTitle: '<p>Demo — Nota con todos los chips del footer</p>',
      description: '<p>Esta card muestra todos los chips: autor, comentarios, sentiment, delivered, recording, pin, direction, call duration, links, attachments, tasks.</p>',
      category: 'GENERAL',
      ownerFullName: 'David Kim',
      createdAt: '2026-02-18T12:00:00.000000',
      lastUpdate: '2026-02-18T12:00:00.000000',
      isPinned: true,
      commentCount: 7,
      attachmentCount: 3,
      linkCount: 2,
      taskCount: 2,
      sentiment: 'positive',
      delivered: true,
      recordingCount: 2,
      direction: 'Outbound',
      callDuration: '4 mins',
    },
    // Mes actual (Feb 2026) - sin encabezado de fecha
    {
      noteUuid: 'edab0289-ad30-41c2-97ff-1ab7c469a41d',
      noteTitle: '<p>Another Test Note with some text note</p>',
      description: '<p>Another Test Note with some text note</p>',
      category: 'GENERAL',
      ownerFullName: 'David Ramirez',
      createdAt: '2026-02-18T18:58:33.402518',
      lastUpdate: '2026-02-18T18:58:33.402518',
    },
    {
      noteUuid: '3ff00a79-62e3-4023-b9de-dd49ff4b283d',
      noteTitle: '<p>Lorem ipsum dolor sit amet, consectetur adipisc</p>',
      description:
        '<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>',
      category: 'GENERAL',
      ownerFullName: 'David Ramirez',
      createdAt: '2026-02-18T14:43:07.728604',
      lastUpdate: '2026-02-18T14:43:07.728604',
      linkCount: 1,
      taskCount: 2,
    },
    {
      noteUuid: '58fe0694-c298-443f-911c-01abe8d3ba19',
      noteTitle: '<p>Nota de febrero - seguimiento cliente</p>',
      description: '<p>Reunión de seguimiento. Cliente interesado en SUV.</p>',
      category: 'GENERAL',
      ownerFullName: 'David Ramirez',
      createdAt: '2026-02-16T10:23:00.000000',
      lastUpdate: '2026-02-16T10:23:00.000000',
      commentCount: 3,
      attachmentCount: 2,
      linkCount: 2,
      taskCount: 1,
      sentiment: 'positive',
    },
    {
      noteUuid: 'a1b2c3d4-e5f6-7890-abcd-ef1234567890',
      noteTitle: '<p>Llamada inicial febrero</p>',
      description: '<p>Primera llamada del mes. Presupuesto discutido.</p>',
      category: 'GENERAL',
      ownerFullName: 'Maria Lopez',
      createdAt: '2026-02-10T09:00:00.000000',
      lastUpdate: '2026-02-10T09:00:00.000000',
    },
    {
      noteUuid: 'feb-extra-01',
      noteTitle: '<p>Test drive programado</p>',
      description: '<p>Cliente agenda test drive para el viernes.</p>',
      category: 'GENERAL',
      ownerFullName: 'David Ramirez',
      createdAt: '2026-02-08T14:00:00.000000',
      lastUpdate: '2026-02-08T14:00:00.000000',
    },
    {
      noteUuid: 'feb-extra-02',
      noteTitle: '<p>Oferta enviada</p>',
      description: '<p>Presupuesto por email. Esperando respuesta.</p>',
      category: 'GENERAL',
      ownerFullName: 'Maria Lopez',
      createdAt: '2026-02-05T11:20:00.000000',
      lastUpdate: '2026-02-05T11:20:00.000000',
    },
    {
      noteUuid: 'feb-extra-03',
      noteTitle: '<p>Primera visita showroom</p>',
      description: '<p>Cliente visitó y mostró interés en dos modelos.</p>',
      category: 'GENERAL',
      ownerFullName: 'David Ramirez',
      createdAt: '2026-02-01T16:30:00.000000',
      lastUpdate: '2026-02-01T16:30:00.000000',
    },
    // Mes pasado (Ene 2026) - con encabezado "JANUARY 2026"
    {
      noteUuid: 'b2c3d4e5-f6a7-8901-bcde-f12345678901',
      noteTitle: '<p>Resumen cierre enero</p>',
      description: '<p>Ventas del mes. Objetivos cumplidos.</p>',
      category: 'GENERAL',
      ownerFullName: 'David Ramirez',
      createdAt: '2026-01-28T16:45:00.000000',
      lastUpdate: '2026-01-28T16:45:00.000000',
    },
    {
      noteUuid: 'c3d4e5f6-a7b8-9012-cdef-123456789012',
      noteTitle: '<p>Reunión con proveedor</p>',
      description: '<p>Negociación de condiciones para Q1.</p>',
      category: 'GENERAL',
      ownerFullName: 'David Ramirez',
      createdAt: '2026-01-20T11:30:00.000000',
      lastUpdate: '2026-01-20T11:30:00.000000',
    },
    {
      noteUuid: 'd4e5f6a7-b8c9-0123-def0-234567890123',
      noteTitle: '<p>Nota antigua enero</p>',
      description: '<p>Seguimiento pendiente desde inicio de año.</p>',
      category: 'GENERAL',
      ownerFullName: 'Maria Lopez',
      createdAt: '2026-01-05T08:15:00.000000',
      lastUpdate: '2026-01-05T08:15:00.000000',
    },
    {
      noteUuid: 'jan-extra-01',
      noteTitle: '<p>Objetivos Q1 definidos</p>',
      description: '<p>Revisión de metas con el equipo comercial.</p>',
      category: 'GENERAL',
      ownerFullName: 'David Ramirez',
      createdAt: '2026-01-15T10:00:00.000000',
      lastUpdate: '2026-01-15T10:00:00.000000',
    },
    {
      noteUuid: 'jan-extra-02',
      noteTitle: '<p>Capacitación nuevo modelo</p>',
      description: '<p>Curso de producto para vendedores.</p>',
      category: 'GENERAL',
      ownerFullName: 'Maria Lopez',
      createdAt: '2026-01-12T09:30:00.000000',
      lastUpdate: '2026-01-12T09:30:00.000000',
    },
    {
      noteUuid: 'jan-extra-03',
      noteTitle: '<p>Inventario enero</p>',
      description: '<p>Conteo y ajuste de stock en showroom.</p>',
      category: 'GENERAL',
      ownerFullName: 'David Ramirez',
      createdAt: '2026-01-03T08:00:00.000000',
      lastUpdate: '2026-01-03T08:00:00.000000',
    },
    // Otro mes (Dic 2025) - con encabezado "DECEMBER 2025"
    {
      noteUuid: 'e5f6a7b8-c9d0-1234-ef01-345678901234',
      noteTitle: '<p>Cierre diciembre 2025</p>',
      description: '<p>Balance anual. Metas revisadas.</p>',
      category: 'GENERAL',
      ownerFullName: 'David Ramirez',
      createdAt: '2025-12-30T17:00:00.000000',
      lastUpdate: '2025-12-30T17:00:00.000000',
    },
    {
      noteUuid: 'f6a7b8c9-d0e1-2345-f012-456789012345',
      noteTitle: '<p>Felicidades equipo</p>',
      description: '<p>Nota de cierre de año para el equipo.</p>',
      category: 'GENERAL',
      ownerFullName: 'Maria Lopez',
      createdAt: '2025-12-20T12:00:00.000000',
      lastUpdate: '2025-12-20T12:00:00.000000',
    },
    {
      noteUuid: 'dec-extra-01',
      noteTitle: '<p>Promo fin de año</p>',
      description: '<p>Lanzamiento campaña diciembre. Descuentos.</p>',
      category: 'GENERAL',
      ownerFullName: 'David Ramirez',
      createdAt: '2025-12-15T11:00:00.000000',
      lastUpdate: '2025-12-15T11:00:00.000000',
    },
    {
      noteUuid: 'dec-extra-02',
      noteTitle: '<p>Revisión flota</p>',
      description: '<p>Mantenimiento vehículos de demostración.</p>',
      category: 'GENERAL',
      ownerFullName: 'Maria Lopez',
      createdAt: '2025-12-10T14:30:00.000000',
      lastUpdate: '2025-12-10T14:30:00.000000',
    },
    {
      noteUuid: 'dec-extra-03',
      noteTitle: '<p>Pedido proveedor</p>',
      description: '<p>Orden de repuestos para enero.</p>',
      category: 'GENERAL',
      ownerFullName: 'David Ramirez',
      createdAt: '2025-12-05T09:15:00.000000',
      lastUpdate: '2025-12-05T09:15:00.000000',
    },
    // NOVEMBER 2025
    {
      noteUuid: 'nov-01',
      noteTitle: '<p>Black Friday resultados</p>',
      description: '<p>Ventas récord. Objetivo superado.</p>',
      category: 'GENERAL',
      ownerFullName: 'David Ramirez',
      createdAt: '2025-11-28T18:00:00.000000',
      lastUpdate: '2025-11-28T18:00:00.000000',
    },
    {
      noteUuid: 'nov-02',
      noteTitle: '<p>Preparación Black Friday</p>',
      description: '<p>Inventario y precios listos para la promoción.</p>',
      category: 'GENERAL',
      ownerFullName: 'Maria Lopez',
      createdAt: '2025-11-20T10:00:00.000000',
      lastUpdate: '2025-11-20T10:00:00.000000',
    },
    {
      noteUuid: 'nov-03',
      noteTitle: '<p>Reunión gerencia noviembre</p>',
      description: '<p>Proyecciones y planificación cierre de año.</p>',
      category: 'GENERAL',
      ownerFullName: 'David Ramirez',
      createdAt: '2025-11-10T15:00:00.000000',
      lastUpdate: '2025-11-10T15:00:00.000000',
    },
    // OCTOBER 2025
    {
      noteUuid: 'oct-01',
      noteTitle: '<p>Cierre octubre</p>',
      description: '<p>Metas del mes cumplidas. Buen ritmo.</p>',
      category: 'GENERAL',
      ownerFullName: 'Maria Lopez',
      createdAt: '2025-10-31T17:30:00.000000',
      lastUpdate: '2025-10-31T17:30:00.000000',
    },
    {
      noteUuid: 'oct-02',
      noteTitle: '<p>Nuevo cliente corporativo</p>',
      description: '<p>Firma contrato flota. 12 unidades.</p>',
      category: 'GENERAL',
      ownerFullName: 'David Ramirez',
      createdAt: '2025-10-15T11:00:00.000000',
      lastUpdate: '2025-10-15T11:00:00.000000',
    },
  ];

const stripHtmlTags = (value = '') =>
  String(value)
    .replace(/<[^>]*>/g, '')
    .replace(/&nbsp;/g, ' ')
    .replace(/&amp;/g, '&')
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&quot;/g, '"')
    .trim();

/**
 * Obtiene el ID de nota (compatible con mapNoteItem).
 */
const getNoteId = (item) => item.note_uuid || item.noteUuid || item.id;

/**
 * Respuesta mock paginada con filtros básicos (temporal para demo UX).
 * Pinned siempre arriba en cada página. Archived al final de la lista pero solo
 * visibles en la última página (participan en la paginación).
 * @param {number} page - Página actual
 * @param {number} pageSize - Tamaño de página
 * @param {object} filters - Filtros (search, category)
 * @param {string[]} pinnedIds - IDs de notas pinned (siempre visibles arriba)
 * @param {string[]} archivedIds - IDs de notas archivadas (al final, solo en última página)
 */
export const getMockNotesListResponse = (
  page = 1,
  pageSize = 10,
  filters = {},
  pinnedIds = [],
  archivedIds = []
) => {
  const searchKeyword = String(filters?.search || '').trim().toLowerCase();
  const categoryFilter = String(filters?.category || 'all').trim().toLowerCase();

  const filteredNotes = MOCK_NOTES_FULL_BODY.filter((item) => {
    const rawTitle = item.noteTitle || item.note_title || '';
    const rawDescription = item.description || item.note_content || '';
    const category = String(item.category || 'GENERAL').toLowerCase();

    const textToSearch = `${stripHtmlTags(rawTitle)} ${stripHtmlTags(rawDescription)}`.toLowerCase();
    const matchesSearch = !searchKeyword || textToSearch.includes(searchKeyword);
    const matchesCategory = categoryFilter === 'all' || category === categoryFilter;

    return matchesSearch && matchesCategory;
  });

  // Pinned arriba en cada página; resto + archived ordenados (archived al final), paginados
  const pinnedNotes = pinnedIds
    .map((id) => filteredNotes.find((n) => getNoteId(n) === id))
    .filter(Boolean);
  const restNotes = filteredNotes.filter(
    (n) => !pinnedIds.includes(getNoteId(n)) && !archivedIds.includes(getNoteId(n))
  );
  const archivedNotes = archivedIds
    .map((id) => filteredNotes.find((n) => getNoteId(n) === id))
    .filter(Boolean);

  const restAndArchived = [...restNotes, ...archivedNotes];
  const total = restAndArchived.length;
  const totalPages = Math.max(1, Math.ceil(total / pageSize));
  const currentPage = Math.min(Math.max(1, page), totalPages);
  const start = (currentPage - 1) * pageSize;
  const pageOfRestAndArchived = restAndArchived.slice(start, start + pageSize);

  const body = [...pinnedNotes, ...pageOfRestAndArchived];

  return {
    statusCode: 200,
    headers: { 'Content-Type': 'application/json' },
    requestId: 'mock-notes-list-request-id',
    msgCode: [{ code: 'ACT_NOTE_LIST_OK', description: 'Notes listed successfully.' }],
    body,
    meta: {
      total_items: total + pinnedNotes.length,
      total_pages: totalPages,
      current_page: currentPage,
      per_page: pageSize,
      has_next: currentPage < totalPages,
      has_previous: currentPage > 1,
      next_cursor: null,
    },
  };
};

/** Respuesta mock completa (página 1, 10 ítems) — compatibilidad si algo importa la respuesta fija. */
export const MOCK_NOTES_LIST_RESPONSE = getMockNotesListResponse(1, 10, {});
